/**
 * 节流函数
 * @param {Function} method - 需要节流的方法
 * @param {number} [delay=100] - 节流间隔(ms)
 * @param {Object} [context] - 方法执行的上下文
 * @param {boolean} [leading=false] - 是否首次立即触发，默认 false 为尾部触发（debounce）
 * @returns {Function} 节流后的函数
 */
export default function throttle(method, delay, context) {
  var leading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var timer = null;
  var lastArgs = null;
  var lastSelf = null;
  return function () {
    var args = arguments;
    var self = this;
    if (leading) {
      // Leading 模式：首次立即执行，同周期内后续调用在 cooldown 结束后执行一次尾部回调
      if (!timer) {
        method.apply(context || self, args);
        timer = setTimeout(function () {
          if (lastArgs) {
            method.apply(context || lastSelf, lastArgs);
            lastArgs = null;
            lastSelf = null;
          }
          timer = null;
        }, delay || 100);
      } else {
        lastArgs = args;
        lastSelf = self;
      }
    } else {
      // 原有尾部触发模式（debounce），向后兼容
      clearTimeout(timer);
      timer = setTimeout(function () {
        method.apply(context || self, args);
      }, delay || 100);
    }
  };
}